import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { Space, Image, Typography, List, Collapse, Tag, Row, Col, Button, Descriptions } from "antd"
import { PlusOutlined } from "@ant-design/icons";

const { Text, Paragraph } = Typography;
const { Panel } = Collapse;
const { Item } = Descriptions;

const PrizesMobile = ({ prizes = [], loadingPrizes }) => {

  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const language = i18next.language.substring(0, 2);
  const locales = language === "en" ? "en-US" : "es-AR";

  return (
    <Row style={{ margin: "0px auto", padding: 16, width: '100%' }}>
      <Col span={24}>
        <List
          style={{ width: '100%' }}
          loading={{ spinning: loadingPrizes, tip: t("prizeTable.loadingPrizes") }}
          itemLayout="horizontal"
          dataSource={prizes}
          renderItem={prize => (
            <Collapse style={{ border: '1px solid black', marginBottom: "16px", width: '100%' }} size="small" accordion >
              <Panel
                key={prize.id}
                header={(
                  <Row style={{ width: '100%' }} align={'middle'} >
                    <Col span={6} style={{ height: '100%' }}>
                      <Image
                        onClick={() => {
                          navigate(`/prizes/${prize.id}/edit`);
                          window.scroll(0, 0);
                        }}
                        width={50}
                        height={50}
                        src={prize.imageUrl}
                        alt={prize.imageUrl}
                        preview={false}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                        wrapperStyle={{ flexShrink: 0 }}
                      />
                    </Col>
                    <Col span={18}>
                      <Paragraph strong style={{ margin: 0, width: '100%', maxWidth: '250px' }} ellipsis={{ rows: 1, tooltip: true }} >
                        {prize.name}
                      </Paragraph>
                      <Space wrap>
                        <Text style={{ color: '#1187CF' }} strong>
                          {t("prizeTable.price")}:
                        </Text>
                        <Space style={{ justifyContent: 'space-around' }}>
                          <Tag color="blue" style={{ margin: 0 }}>{prize.price}</Tag>
                        </Space>
                      </Space>
                    </Col>
                  </Row>
                )}
              >
                <Space direction="vertical" style={{ height: '100%', width: '100%' }}>
                  {prize.available ? (
                    <Tag color="success">{t("prizeTable.available")}</Tag>
                  ) : (
                    <Tag color="error">{t("prizeTable.unavailable")}</Tag>
                  )}
                  <Descriptions size="small" column={2} layout="vertical" style={{ width: '100%' }}>
                    <Item labelStyle={{ fontWeight: 'bold' }} label={t("prizeTable.cost")}>
                      ${prize.cost.toLocaleString(locales)}
                    </Item>
                    <Item labelStyle={{ fontWeight: 'bold' }} label={t("prizeTable.currency")}>
                      {prize.currency.symbol}
                    </Item>
                    <Item labelStyle={{ fontWeight: 'bold' }} label={t("prizeTable.stockType")}>
                      {prize.stockType}
                    </Item>
                    <Item labelStyle={{ fontWeight: 'bold' }} label={t("prizeTable.stockAmount")}>
                      {prize.stockAmount}
                    </Item>
                    <Item
                      label={t("prizeTable.description")}
                      labelStyle={{ fontWeight: 'bold' }}
                      span={2}
                      style={{ width: '100%', gridColumn: 'span 2' }}
                    >
                      {prize.description}
                    </Item>
                  </Descriptions>
                </Space>
              </Panel>
            </Collapse>
          )}
        />
      </Col>
      <Col span={24}>
        <Button
          type="primary"
          style={{ width: '100%' }}
          icon={<PlusOutlined />}
          onClick={() => {
            navigate(`/prizes/create`);
            window.scroll(0, 0);
          }}
        >
          {t("prizeTable.add")}
        </Button>
      </Col>
    </Row >
  )
}

export default PrizesMobile;